module.exports = __webpack_public_path__ + "static/media/vertical-window.e4421c7c.png";